import { B2C_BALANCE_ELIGIBILITY } from "@swiggy-private/checkout-types";

import { SwiggyMoneyInfoHalfCardModel } from "./SwiggyMoney";

export interface SplitPayMeta {
    iconUrl: string;
    promoMsg: string;
    disableMessage: string;
    offerMessage: string;
    bannerMessage: string;
    backgroundColor: string;
    textColor: string;
    infoMessageWithCta?: string;
    infoMessageWithoutCta?: string;
    learnMoreHalfCard?: SwiggyMoneyInfoHalfCardModel;
    paymentGroupBannerData?: string;
    rewardId?: string;
    balanceEligibility?: B2C_BALANCE_ELIGIBILITY;
    expenseCodeRequired?: boolean;
    showExpenseCodeHalfCard?: boolean;
    expenseCodes?: string[];
    billUploadRequired?: boolean;
    eligibleApp?: string;
}

export interface SplitPayData {
    name: string;
    displayName: string;
    paymentCode: string;
    enabled: boolean;
    couponApplicable: boolean;
    meta: SplitPayMeta;
    showLearnMoreHalfCard: boolean;
    select: boolean;
    title: string;
    balance: string;
    eligibleBalance: string;
    showAddMoneyCta: boolean;
    addMoneyCtaMessage?: string;
    isReward: boolean;
    poweredBy?: string;
    splitPayIdentifier: string;
    rewardApplicable: boolean;
    rewardId?: number;
    upiAppUnavailable?: boolean;
}

export enum SPLITPAY_POWERED_BY {
    TWID = "TwidRewards",
    DIRECT = "direct",
}

export enum SPLITPAY_SELECTION_TYPE {
    TOGGLE,
    TICK,
}

export interface SplitpayAnalyticsEvents {
    splitpayGroupImpressionEvent?: () => void;
    splitpayClickEvent?: (context: string) => void;
    viewAllRewardsCtaImpressionEvent?: () => void;
    viewAllRewardsCtaClickEvent?: () => void;
    rewardsHalfCardImpressionEvent?: () => void;
    rewardsInHalfcardClickEvent?: (rewardName: string, selected: boolean) => void;
    crossClickEvent?: () => void;
}
